import React, { useEffect } from 'react';
import './Coverage.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Meta from './Meta';

export function Coverage() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
      <React.Fragment>
      <Meta
        title="Карта покрытия интернета от «ИТ Особа»: проверьте подключение в вашем доме"
        description="Проверьте, доступен ли наш высокоскоростной интернет по вашему адресу. Интерактивная карта покрытия сети в Подольске, Москве, Домодедово, Видном, Щербинке и других населенных пунктах Московской области."
      />
    <div className="coverage-container" data-aos="fade-up">
      <h2 className="coverage-title" data-aos="fade-down">Карта покрытия:</h2>
      <p className="coverage-description" data-aos="fade-up" data-aos-delay="100">
        Мы работаем в разных районах. Посмотрите наше покрытие на карте.
      </p>
      <div className="coverage-map-wrapper" data-aos="zoom-in" data-aos-delay="150">
        <iframe
          src="https://yandex.ru/map-widget/v1/?ll=37.885029%2C55.361165&mode=usermaps&source=constructorLink&um=constructor%3Abeb61ec29c10d9bd4e4c310d2853759a7b200a10988ac2dbf74e86dd629ebf99&z=11"

          className="coverage-iframe"
          frameBorder="0"
          allowFullScreen
          title="Карта покрытия"
        />
      </div>
      {/* <div className="coverage-contact" data-aos="fade-up" data-aos-delay="200">
        <a href="/contacts" className="btn-contact">Связаться с нами</a>
      </div> */}
    </div>
    </React.Fragment>
  );
}